import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import { applyMiddleware, createStore, combineReducers, Store, Action } from 'redux';
import reducers from './reducers';
import sagas from './sagas';
import { TYPES } from './user/constants';
import { ReduxState } from './types';

export const sagaMiddleware = createSagaMiddleware();
const appReducer = combineReducers(reducers);

const rootReducer = (state: ReduxState | undefined, action: Action) => {
  if (action.type === TYPES.LOGOUT.SUCCESS) {
    state = undefined;
  }

  return appReducer(state, action);
};

const middlewares = applyMiddleware(sagaMiddleware);
// Technical Debt: Need to split on dev and prod
// const enhancer = true ? composeWithDevTools(middlewares) : middlewares;
const enhancer = composeWithDevTools(middlewares);

const store: Store = createStore(rootReducer, enhancer);

sagaMiddleware.run(sagas);

export default store;
